import { useState } from "react";
import { Check, Copy } from "lucide-react";
import styled from "styled-components";

import { useLandingLanguage } from "../../contexts/landing-language";
import { shareLinks } from "./paths";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #5e6278;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Pill = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  background: ${(props) => props.$bg};
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.92;
  }
`;

const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  color: #1a1a1a;
  background: #f2f0ec;
  border: 1px solid #e3ded6;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    background 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: #eae6df;
  }
`;

const CHANNELS = [
  { key: "whatsapp", label: "WhatsApp", bg: "#25D366" },
  { key: "facebook", label: "Facebook", bg: "#1877F2" },
  { key: "x", label: "X", bg: "#000000" },
  { key: "telegram", label: "Telegram", bg: "#229ED9" },
  { key: "line", label: "LINE", bg: "#06C755" },
  { key: "linkedin", label: "LinkedIn", bg: "#0A66C2" },
  { key: "pinterest", label: "Pinterest", bg: "#E60023" },
  { key: "email", label: "Email", bg: "#5E6278" },
];

const ShareBar = ({ url, title }) => {
  const { t } = useLandingLanguage();
  const [copied, setCopied] = useState(false);
  const links = shareLinks(url, title);

  const copy = () => {
    navigator.clipboard?.writeText(url).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Wrap>
      <Label>{t.insights.detail.share}</Label>
      <Row>
        {CHANNELS.map((channel) => (
          <Pill
            key={channel.key}
            href={links[channel.key]}
            target="_blank"
            rel="noopener noreferrer"
            $bg={channel.bg}
          >
            {channel.label}
          </Pill>
        ))}
        <CopyButton type="button" onClick={copy}>
          {copied ? <Check size={14} /> : <Copy size={14} />}
          {copied ? t.insights.detail.copied : t.insights.detail.copyLink}
        </CopyButton>
      </Row>
    </Wrap>
  );
};

export default ShareBar;
